export class AbstractPlayer {
    constructor(desiredVideoQuality, logger) {
        this.desiredVideoQuality = desiredVideoQuality;
        this.logger = logger;
        this.activeTimers = new Set();
    }
    /**
     * Clears all pending planAction timers. Subclasses should call this
     * in their idle() and destroy() implementations to prevent timer leaks.
     */
    clearAllTimers() {
        for (const timer of this.activeTimers) {
            clearTimeout(timer);
            clearInterval(timer);
        }
        this.activeTimers.clear();
    }
    queue(item, from, until) {
        this.preload(item);
        this.play(item, from);
        if (from.getTime() < Date.now() && (item.playable.type === 'video' || item.playable.type === 'audio')) {
            const elapsedTime = Date.now() - from.getTime(); // elepsed time since "from" in ms
            const syncAt = (Math.ceil(elapsedTime / 1000) + 3) * 1000; // slot-relative moment of the seek, ms since "from"
            // The media position additionally carries start_at: a resumed item's slot
            // begins mid-track, so seeking to the slot offset alone lands too early.
            const seekTo = syncAt + (item.start_at || 0);
            const whenItWillHappen = new Date();
            whenItWillHappen.setMilliseconds(whenItWillHappen.getMilliseconds() + syncAt - elapsedTime);
            if (whenItWillHappen > new Date(new Date(until).setSeconds(until.getSeconds() - 2))) {
                // item will be stopped before we need to seek
                return;
            }
            // we must seek to the correct position if the "from" time is in the past
            this.logger.info('[AbstractPlayer] Scheduling sync for playback ID:' + item.id + ' to ' + seekTo + ' ms at ' + whenItWillHappen.toISOString());
            this.sync(item, seekTo, whenItWillHappen);
        }
        this.stop(item, until, false);
    }
    planAction(when, callback) {
        const scheduledForFuture = when.getTime() > Date.now();
        const isMoreThanFiveSecondsAway = when.getTime() - Date.now() > 5000;
        const timeout = setTimeout(() => {
            const interval = setInterval(() => {
                if (Date.now() >= when.getTime()) {
                    clearInterval(interval);
                    this.activeTimers.delete(interval);
                    this.activeTimers.delete(timeout);
                    const delayMs = Date.now() - when.getTime();
                    if (scheduledForFuture && delayMs > AbstractPlayer.PLAN_ACTION_DELAY_WARN_MS) {
                        this.logger.warning('[AbstractPlayer] planAction callback fired late — likely event-loop block', {
                            delayMs,
                            plannedAt: when.toISOString(),
                            firedAt: new Date().toISOString(),
                        });
                    }
                    callback();
                }
            }, 2);
            this.activeTimers.add(interval);
        }, isMoreThanFiveSecondsAway ? when.getTime() - Date.now() - 5000 : 0);
        this.activeTimers.add(timeout);
        return timeout;
    }
}
AbstractPlayer.PLAN_ACTION_DELAY_WARN_MS = 500;
//# sourceMappingURL=AbstractPlayer.js.map